import { z } from 'zod';
import type { FieldsDisplayedSchema } from '~/shared/domain/models';

export const generateFieldOptional =
  (field: FieldsDisplayedSchema) =>
  (
    baseSchema:
      | z.ZodString
      | z.ZodArray<z.ZodString, 'many'>
      | z.ZodNumber
      | z.ZodEffects<z.ZodString, string, string>,
  ) =>
    field.validations?.required ? baseSchema : baseSchema.optional().nullable().or(z.literal(''));
